import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'search',
      component: () => import('../views/Index.vue'),
    },

    {
      path: '/detail/:id',
      name: 'detail',
      component: () => import('../views/Detail.vue'),
    },

    {
      path: '/kennel',
      name: 'kennelList',
      component: () => import('../views/KennelList.vue'),
    },

    {
      path: '/kennel/:id',
      name: 'kennelDetail',
      component: () => import('../views/Kennel.vue'),
    },

    {
      path: '/beauty',
      name: 'beauty',
      component: () => import('../views/Beauty.vue'),
    },
  ],
})

export default router
